import axios from 'axios';
// import { data } from 'react-router-dom';

// Define the base URL for the API
const API_BASE_URL = process.env.REACT_APP_BASE_URL;


/**
 * Fetch product subcategories
 */
export const requestOtp = async (data) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/account/request-otp/`, data);
      return {
        data: response.data, 
        status: response.status 
      };
    } catch (error) {
      console.error('Error requesting OTP:', error);
      throw error;
    }
};

export const loginRegisterVerifyOtp = async (data) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/account/login-register/`, data);
      return response.data;
    } catch (error) {
      console.error('Error requesting OTP:', error);
      throw error;
    }
};

export const getUserCurrentLocation = async ({ latitude, longitude }) => {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching current location:', error);
    throw error;
  }
};


export const fetchWithAuth = async (url, options = {}) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const headers = {
      ...options.headers,
      Authorization: `Bearer ${accessToken}`,
    };

    // Make the API request
    const response = await fetch(url, {
      ...options,
      headers,
    });

    // Check if the token has expired (401 Unauthorized)
    if (response.status === 401) {
      console.warn("Access token expired. Attempting to refresh...");
      const refreshToken = localStorage.getItem("refreshToken");

      // Call the refresh token API
      const refreshResponse = await fetch(`${API_BASE_URL}/account/token/refresh/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refresh: refreshToken }),
      });

      if (refreshResponse.ok) {
        const refreshData = await refreshResponse.json();

        // Update the tokens in localStorage
        localStorage.setItem("accessToken", refreshData.access);
        localStorage.setItem("refreshToken", refreshData.refresh);

        // Retry the original request with the new access token
        const retryHeaders = {
          ...headers,
          Authorization: `Bearer ${refreshData.access}`,
        };

        const retryResponse = await fetch(url, {
          ...options,
          headers: retryHeaders,
        });

        return retryResponse;
      } else {
        console.error("Failed to refresh token:", await refreshResponse.text());
        throw new Error("Session expired. Please log in again.");
      }
    }

    return response;
  } catch (error) {
    console.error("Failed to fetch with authorization:", error);
    throw error;
  }
};

export const fetchUserDetails = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/get-user-details/`, {
      method: "GET",
    });

    if (response.ok) {
      const userDetails = await response.json();
      console.log("User Details:", userDetails);
      return userDetails; // Return the data if needed
    } else {
      console.error("Failed to fetch user details:", await response.text());
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};

export const fetchUserAddresses = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/addresses/`, {
      method: "GET",
    });

    if (response.ok) {
      const userAddresses = await response.json();
      console.log("User Addresses:", userAddresses);
      return userAddresses; // Return the data if needed
    } else {
      console.error("Failed to fetch user addresses:", await response.text());
    }
  } catch (error) {
    console.error("Error fetching user addresses:", error);
  }
};

export const addAddress = async (addressPayload) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/addresses/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addressPayload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to add address: ${errorText}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error adding address:", error);
    return { success: false, error: error.message };
  }
};


export const updateUser = async (userPayload) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/update-user/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userPayload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to update user: ${errorText}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error updating user:", error);
    return { success: false, error: error.message };
  }
};

export const updateAddress = async (id,addressPayload) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/addresses/${id}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addressPayload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to add address: ${errorText}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error adding address:", error);
    return { success: false, error: error.message };
  }
};

export const VerifyOtpAfterLogin = async (userPayload) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/verify-otp/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userPayload),
    });
    // return response;
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to update user: ${errorText}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error requesting OTP:', error);
    throw error;
  }
};